import { render } from "./ProduitPartenariatPage.vue?vue&type=template&id=7e958a59"
import script from "./ProduitPartenariatPage.vue?vue&type=script&lang=js"
export * from "./ProduitPartenariatPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__